import{m as e}from"./chunk-HBP5N4FR.js";e();var t=`.dapp-core-component__detailItem-module__detail-item:last-child {
  border-bottom: 0;
}`;document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(t));var a={"detail-item":"dapp-core-component__detailItem-module__detail-item",detailItem:"dapp-core-component__detailItem-module__detail-item"};export{t as a,a as b};
//# sourceMappingURL=chunk-SNEQ5LP2.js.map
